import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import uuid from "react-uuid";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useOutletContext } from "react-router";

import { OrderHistoryContainer } from "./styled";
import { FaChevronLeft } from "react-icons/fa6";

import OrderGroup from "../common/orderGroup";
import SectionHeader from "../common/sectionTitle";
import { useSelector } from "react-redux";
import PeriodSelector from "./orderHistory/periodSelector";
import CancelModal from "./orderHistory/cancelModal";

const OrderHistory = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const { openModal, closeModal } = useOutletContext();

  const user = useSelector((state) => state?.user?.data[0]);

  const [periodLabel, setPeriodLabel] = useState("1주일");
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(7, "days").format("YYYY-MM-DD"),
    end: moment().format("YYYY-MM-DD"),
  });
  const [selection, setSelection] = useState(null);
  const [dialogType, setDialogType] = useState("");

  const [orders, setOrders] = useState([]);

  const getPeriodRange = (period) => {
    const map = {
      "1주일": 7,
      "1개월": 30,
      "3개월": 90,
      "6개월": 180,
    };
    return map[period] || 7;
  };

  useEffect(() => {
    getOrders();
  }, []);

  const handlePeriodChange = (period) => {
    setPeriodLabel(period);
    const days = getPeriodRange(period);

    setDateRange({
      start: moment().subtract(days, "days").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
    });
  };

  const getOrders = async () => {
    try {
      const body = {
        filter: {
          fromDate: dateRange.start,
          toDate: dateRange.end,
          mberNo: user.mberNo,
        },
      };

      const { data } = await axios.post("/erp/customerOrders", body);
      console.log(data);
      setOrders(data?.orders || []);
    } catch (err) {
      console.error("주문 조회 실패", err);
    }
  };

  const changeDate = (e) => {
    const { name, value } = e.target;
    if (!value) return;

    setDateRange((prev) => ({ ...prev, [name]: value }));
  };

  const toggleModal = (item = null, type = "") => {
    setSelection(item);
    setDialogType(type);
  };

  const getModal = () => {
    switch (dialogType) {
      case "cancel":
        return (
          <CancelModal
            toggleModal={toggleModal}
            selection={selection}
            openModal={openModal}
            closeModal={closeModal}
            getData={getOrders}
          />
        );
    }
  };

  return (
    <>
      <OrderHistoryContainer>
        {dialogType && getModal()}
        <h2>
          {isMobile && (
            <button onClick={() => navigate(`/shop/mypage`)}>
              <FaChevronLeft />
            </button>
          )}
          <span>주문/배송조회</span>
        </h2>
        <PeriodSelector
          changeDate={changeDate}
          dateRange={dateRange}
          getOrders={getOrders}
          periodLabel={periodLabel}
          handlePeriodChange={handlePeriodChange}
        />
        <SectionHeader title="주문 상품 정보" withLine />
        <ul>
          {orders.map((item) => (
            <OrderGroup
              key={item.id || uuid()}
              item={item}
              openModal={openModal}
              closeModal={closeModal}
              toggleModal={toggleModal}
            />
          ))}
        </ul>
      </OrderHistoryContainer>
    </>
  );
};

export default OrderHistory;
